// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cY8l","buttons":"styles_buttons__PZ9qH"};